import styles from "./app.module.scss";

function App() {
    return (
        <main className={`${styles.grid} ${styles.main}`}>
            <h1 className={styles.col_1}>Dear Jones,</h1>
            <section className={`${styles.col_2} richtext`}>
                <p>
                    Represents and supports the careers of a selected group of
                    emerging and established photographers and directors
                </p>
                <p>Based in Copenhagen, working internationally</p>
                <p>
                    Say hello at{" "}
                    <a href="mailto:info@dearjones.tv">info@dearjones.tv</a>
                </p>
                <p>
                    Tel. <a href="tel:004528910120">+45 2891 0120</a>
                </p>
            </section>
            <footer className={`${styles.col_2} ${styles.footer}`}>
                <p>All Rights Reserved © 2026</p>
            </footer>
        </main>
    );
}

export default App;
